function initGymsharkDots(gallery) {
  if (gallery.dataset.gsDotsInit === '1') return;
  gallery.dataset.gsDotsInit = '1';

  const track = gallery.querySelector('.product__media-list');
  const btns  = [...gallery.querySelectorAll('.slider-counter__link--dots')];
  if (!track || btns.length < 2) return;

  // dot spans sicherstellen
  btns.forEach((b) => {
    if (!b.querySelector('.dot')) {
      const s = document.createElement('span');
      s.className = 'dot';
      b.appendChild(s);
    }
  });

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  let cachedSlideW = 0;
  const measureSlideW = () => {
    const first = track.querySelector('.product__media-item');
    cachedSlideW = first ? first.getBoundingClientRect().width : track.clientWidth;
  };
  measureSlideW();

  const setA = (i, val) => btns[i].style.setProperty('--a', val.toFixed(4));

  const update = () => {
    const w = cachedSlideW || track.clientWidth;
    const prog = track.scrollLeft / w;     // 0..N
    const maxI = btns.length - 1;

    const i0 = clamp(Math.floor(prog), 0, maxI);
    const i1 = clamp(i0 + 1, 0, maxI);
    const t  = clamp(prog - i0, 0, 1);

    // alle reset
    for (let i = 0; i < btns.length; i++) setA(i, 0);

    // Gymshark: aktueller schrumpft, nächster wächst
    setA(i0, 1 - t);
    if (i1 !== i0) setA(i1, t);

    // aria-current nur für accessibility (optional)
    const active = clamp(Math.round(prog), 0, maxI);
    btns.forEach((b, i) => b.setAttribute('aria-current', i === active ? 'true' : 'false'));
  };

  let raf = 0;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  }, { passive: true });

  btns.forEach((btn, i) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      track.scrollTo({ left: i * cachedSlideW, behavior: 'smooth' });
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => { measureSlideW(); update(); }, 200);
  });
  update();
}

function initAll() {
  document.querySelectorAll('media-gallery').forEach(initGymsharkDots);
}

document.addEventListener('DOMContentLoaded', initAll);
document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll?.('media-gallery').forEach((g) => {
    delete g.dataset.gsDotsInit;
    initGymsharkDots(g);
  });
});